import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";
import { crmContacts } from "./contacts";
import { crmOrganizations } from "./organizations";
import { workflows } from "@kubdee/module-core/schemas/workflow-workflows";

// ============================================================================
// crm_deals — ดีล/โอกาสการขาย
// ============================================================================
export const crmDeals = sqliteTable("crm_deals", {
  id: text("id").primaryKey(), // ULID
  dealNo: text("deal_no"),
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  contactId: text("contact_id").references(() => crmContacts.id),
  organizationId: text("organization_id").references(() => crmOrganizations.id),
  status: text("status", {
    enum: ["open", "won", "lost"],
  }).notNull().default("open"),
  docStatus: integer("doc_status").notNull().default(0), // 0=Draft, 1=Submitted, 2=Cancelled
  workflowId: text("workflow_id").references(() => workflows.id),
  currentStateKey: text("current_state_key"),
  lostReasonId: text("lost_reason_id"), // FK → crm_lost_reasons — no constraint to avoid circular
  amount: real("amount").default(0),
  currency: text("currency").default("THB"),
  probability: integer("probability").default(0),
  expectedCloseDate: text("expected_close_date"),
  closedAt: text("closed_at"),
  assignedTo: text("assigned_to"),
  source: text("source"),
  leadId: text("lead_id"), // FK → crm_leads — no constraint
  customerId: text("customer_id"), // FK → customers (accounting) — no constraint
  invoiceId: text("invoice_id"), // FK → invoices (accounting) — no constraint
  quotationId: text("quotation_id"), // FK → quotations — no constraint
  remarks: text("remarks"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyStatusIdx: index("deal_company_status_idx").on(table.companyId, table.status, table.createdAt),
  companyAssignedIdx: index("deal_company_assigned_idx").on(table.companyId, table.assignedTo),
}));

// Type exports
export type CrmDeal = typeof crmDeals.$inferSelect;
export type NewCrmDeal = typeof crmDeals.$inferInsert;
